// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"0":"94a188cb72949dd2278f","405":"ae66355ad35d9f649c9b","837":"09666f0776ee0a5f0612","885":"6bc4894e2764d263d33a"}[chunkId] + ".js";
};